<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.deliveredReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <v-select
            :items="branchesList"
            v-model="branches"
            multiple
            autocomplete
            hide-details
            chips
            deletable-chips
            label="Branch"
            clearable
          />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="option"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime1"
            :option="option1"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <v-btn
            style="height: auto; padding-left: 0px; padding-right: 0px"
            @click="getData()"
            depressed
          >&nbsp; {{ $t('reports.apply') }}</v-btn>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 card-container">
          <div class="shipping">
            <div class="card-title">{{ $t('reports.totalShippingCardTitle') }}<span class="col-sub"><b>A</b> {{ $t('reports.equalsSigmaShippingCost') }}</span></div>
            <div class="card-content">${{ fmt(apiResult.shipping_sum) }}</div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 card-container">
          <div class="fee">
            <div class="card-title">{{ $t('reports.totalShipzoneFeeCardTitle') }}<span class="col-sub"><b>B</b> {{ $t('reports.equalsSigmaShipzoneServiceFee') }}</span></div>
            <div class="card-content">${{ fmt(apiResult.shipzone_fee) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'

export default {
  $_veeValidate: {
    validator: 'new'
  },

  components: {
    'date-picker': myDatepicker
  },

  data() {
    return {
      branchesList: [],
      branches: [],
      apiResult: {},
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.fromDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.toDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    }
  },

  mounted() {
    this.initCurrentMonth()
    this.getConnectedBranches()
  },

  methods: {
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.startTime1.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    getConnectedBranches() {
      this.branchesList = []
      let token = localStorage.getItem('access_token')
      axios
        .get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data
          result.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    getData() {
      if (this.startTime.time.length === 0 || !this.startTime1.time.length === 0) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }

      let form = {
        from_date: this.startTime.time,
        to_date: this.startTime1.time,
        branches_id: this.branches
      }

      let token = localStorage.getItem('access_token')
      axios
        .post('api/delivered_report', form, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.apiResult = response.data.data
        })
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.card-container {
  padding: 16px;
}
.shipping {
  padding: 10px 16px;
  border-radius: 4px;
  background-color: #e57373;
}
.fee {
  padding: 10px 16px;
  border-radius: 4px;
  background-color: #64b5f6;
}

.card-title {
  font-size: 18px;
  text-align: center;
  display: block;
  width: 100%;
  font-weight: bold;
}

.card-content {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
  display: block;
  width: 100%;
}

.col-sub {
  display: block;
  font-weight: 400;
  font-size: 11px;
  opacity: 0.85;
  line-height: 1.2;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/deliveredReport.vue